import services from "@src/Services";

export const initialLoderState = {
  mainLoader: true,
  loadMoreLoader: true,
};

export const getCustomExtraPathNotificationDashboard = (
  customFilter: CustomNotificationFilterType
) => {
  let path = "";
  const { property, store, rvc, date, page, filterBy, unreadOnly } =
    customFilter || {};

  if (property) {
    path += `?property=${property?.toString().trim()}`;
  }

  if (store) {
    path += `&store=${store?.toString().trim()}`;
  }

  if (rvc) {
    path += `&rvc=${rvc?.toString().trim()}`;
  }

  if (date) {
    path += `&date=${date?.toString().trim()}`;
  }

  if (filterBy) {
    path += `&filter_by=${filterBy?.toString()}`;
  }

  if (unreadOnly) {
    path += `&unread_only=${unreadOnly?.toString()}`;
  }

  if (page) {
    path += `&page=${page?.toString()}`;
  }

  let url = path;
  if (path.length && path[0] !== "?") {
    url = url.replace("&", "?");
  }
  return url;
};

export const getNotificationFilter = (filterType: NotificationFitlerType[]) => {
  const FilterBy = filterType?.filter((e) => e?.isSelected);
  const notificationFilterBy = FilterBy.map((e) => e.key).join(",");
  return notificationFilterBy;
};

export const getNotificationList = async (
  filters: CustomNotificationFilterType
) => {
  try {
    const advancedFilterExtraPath = getCustomExtraPathNotificationDashboard({
      ...filters,
    });

    const customPath = `${advancedFilterExtraPath}`;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: any = await services.get(`/notification${customPath}`);
    if (!res?.error) {
      return { data: res?.data?.data };
    }
    return { data: null, error: "Something went wrong !" };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return {
      error: err?.error?.message || "Something went wrong!",
    };
  }
};
